/**
 * Carga de Google Adsense
 *
 * Incluir un componente de adsense en la página
 *
 * <x-adsense slot="6193488932"></x-adsense>
 *
 * @link https://www.mendikat.net
 * @author Javi Urrutia <javi@mendikat.net>
 * @copyright 2023-2026 Mendikat
 * @license Mendikat
 *
 *
 */

const Adsense =
    {
        /**
         * El máximo de anuncios que se pueden llegar a cargar
         *
         */
        maxAds: 24,

        /**
         * El tiempo antes de cargar los anuncios en milisegundos
         *
         */
        timeout: 2000,

        /**
         * Cuando la instancia está montada
         *
         */
        mounted: function () {
            // Carga los anuncios de adsense con un retraso con respecto a la carga de la página
            // controlando el número máximo de anuncios cargados
            setTimeout(() => {
                var calls = 0;
                while (calls <= Adsense.maxAds) {
                    try {
                        (adsbygoogle = window.adsbygoogle || []).push({});
                        ++calls;
                    } catch (e) {
                        break;
                    }
                }

                if (calls > 0) {
                    console.info(`${new Date().toLocaleString()} adsbygoogle: ${calls}, time: ${Adsense.timeout/1000} s`);
                }
            }, Adsense.timeout);
        },
    };

export default Adsense;
